export default "__VITE_PUBLIC_ASSET__0cbd3efd__"